module.exports = __webpack_public_path__ + "img/trash_can.698df941.svg";